import Box from "@mui/material/Box";
import styled from "@mui/material/styles/styled";
import { toAssetImages } from "src/lib/utils";

export const StyledHorizontalCard = styled(Box)(({ theme }) => ({
  maxHeight: "90px",
  height: "100%",
  margin: "auto",
  borderRadius: ".5rem",
  overflow: "hidden",
  position: "relative",
  transition: "all 250ms ease-in-out",
  background: theme.palette.background.paper,
  border: "1px solid #EBEBF0",
  "&:hover": {
    boxShadow: theme.shadows[2],
    "& .controlBox": {
      display: "flex",
      bottom: 0,
    },
  },
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
}));
export const StyledCard = styled(Box)(({ theme }) => ({
  height: "100%",
  margin: "auto",
  borderRadius: ".5rem",
  overflow: "hidden",
  position: "relative",
  transition: "all 250ms ease-in-out",
  background: theme.palette.background.paper,
  border: "1px solid #EBEBF0",
  "&:hover": {
    boxShadow: theme.shadows[2],
    "& .controlBox": {
      display: "flex",
      bottom: 0,
    },
  },
  display: "flex",
  flexDirection: "column",
}));
export const FeaturedImgBox = styled("div", { shouldForwardProp: (props) => props !== "bgImg" })(
  ({ theme, bgImg }) => ({
    overflow: "hidden",
    position: "relative",
    backgroundImage: bgImg ? `url('${toAssetImages(bgImg)}')` : "inherit",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    borderRadius: ".5rem",
  }),
);

export const ContentWrapper = styled("div")({
  flex: 1,
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  padding: "1rem",
  "& .title": {
    flex: "1 0 auto",
    margin: 0,
  },
});
